import { render, staticRenderFns } from "./user-edit.vue?vue&type=template&id=436a8f88&scoped=true&"
import script from "./user-edit.vue?vue&type=script&lang=js&"
export * from "./user-edit.vue?vue&type=script&lang=js&"
import style0 from "./user-edit.vue?vue&type=style&index=0&id=436a8f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436a8f88",
  null
  
)

export default component.exports